import React, {Fragment, PureComponent} from 'react';
import PublicHeader from './../../components/header/index';
import {Button, List, ListView, WhiteSpace, Tabs, Carousel, Flex, WingBlank, Modal} from 'antd-mobile';
import {Icon} from 'antd';
import history from './../../utils/history';
import {connect} from 'react-redux';
import {IMAGE_URL} from './../../utils/api';
import './index.scss'

import {getVenueDetail, getDetailInfo} from './store/actionCreators';


const Item = List.Item;

const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);
const alert = Modal.alert;

class Space extends PureComponent {

    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            tabType: 1,
            venueId: this.props.location.state.id,
            date: now,
            time: now,
            visible: false,
            imgHeight: 176,
            detailInfo: [],

        }

    }

    spaceList = () => {

    }

    openMap = (name, address) => {
        window.wx.getLocation({
            type: 'gcj02', // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
            success: function (res) {
                // success
                console.log(res)
                console.log(res.latitude);
                console.log(res.longitude);
                window.wx.openLocation({
                    latitude: res.latitude, // 纬度，范围为-90~90，负数表示南纬
                    longitude: res.longitude, // 经度，范围为-180~180，负数表示西经
                    scale: 28, // 缩放比例
                    name: name,
                    address: address
                })
            }
        })
    }

    componentDidMount() {
        this.props.getVenueDetail(this.state.venueId);
    }

    handleNavUrl(url, param) {
        history.push(url, {date: param.obj.date, id: this.state.venueId, type: this.state.tabType});
    }

    tabClick = (tab, index) => {
        this.setState({
            tabType: tab.type
        })
    }

    renderTabContent = (tab) => {
        const venueInfo = this.props;
        let {dataSource} = this.state;
        let index = 0;
        const row = (rowData, sectionID, rowID) => {
            if (index < this.state.detailInfo.length - 1) {
                index = index++
            }
            const obj = this.state.detailInfo[index++];
            return (
                <div>
                    <Item extra={<Button size="small" inline
                                         style={{
                                             marginRight: '4px',
                                             color: "#FD9D24",
                                             border: "1px #FD9D24 solid",
                                             borderRadius: "20px",
                                         }}
                                         onClick={() => {
                                             this.handleNavUrl("/spaceDetail", {obj})
                                         }}>预定</Button>}>{obj.date}（{obj.week}）</Item>
                </div>
            );
        };
        return (
            <ListView
                renderHeader={() => <>
                <div className="item-logo"/>
                场地信息</>}
                dataSource={dataSource.cloneWithRows(venueInfo.venueInfo.specialChargeTitleDTO)}
                renderRow={row}
                className="am-list"
                pageSize={4}
                useBodyScroll
                onScroll={() => {
                    console.log('scroll');
                }}
                scrollRenderAheadDistance={500}
                onEndReached={this.onEndReached}
                onEndReachedThreshold={10}
            />
        )
    }

    render() {
        const venueInfo = this.props;
        if (venueInfo.venueInfo.specialChargeTitleDTO) {
            this.state.detailInfo = venueInfo.venueInfo.specialChargeTitleDTO;
        }

        return (
            <div>
                <PublicHeader title="场馆详情"/>
                <div>
                    {venueInfo.venueInfo.specialChargeTitleDTO ?
                        <div>
                            {venueInfo.venueInfo.img ? <Carousel
                                    autoplay={false}
                                    infinite
                                >
                                    <img
                                        src={IMAGE_URL + venueInfo.venueInfo.img}
                                        alt={venueInfo.venueInfo.name}
                                        style={{width: '100%', height: '180%', verticalAlign: 'top'}}
                                        onLoad={() => {
                                            // fire window resize event to change height
                                            window.dispatchEvent(new Event('resize'));
                                            this.setState({imgHeight: 'auto'});
                                        }}
                                    />
                                </Carousel>
                                :
                                <div></div>
                            }
                            <WingBlank>
                                <Tabs tabs={venueInfo.venueInfo.siteTypeList} initialPage={0} animated={false}
                                      useOnPan={false} onTabClick={this.tabClick}
                                      tabBarUnderlineStyle={{border: "1px #FD9D24 solid"}}
                                      tabBarActiveTextColor="#FD9D24"
                                >
                                    {this.renderTabContent}
                                </Tabs>
                            </WingBlank>
                        </div>
                        :
                        <div>暂无场次</div>
                    }
                </div>
                <WhiteSpace/>
                <WingBlank>
                    <Flex.Item>
                        <List renderHeader={() => <>
                        <div className="item-logo"/>
                        <span>场馆信息</span></>}>
                            <Item
                                thumb={<Icon type="idcard" style={{color: "#FD9D24"}}/>}
                                onClick={() => {
                                }}
                            >{venueInfo.venueInfo.name}</Item>
                            <Item
                                thumb={<Icon type="environment" style={{color: "#FD9D24"}}/>}
                                arrow="horizontal"
                                multipleLine
                                wrap="true"
                                onClick={() => {
                                    const name = venueInfo.venueInfo.name;
                                    const address = venueInfo.venueInfo.address;
                                    this.openMap(name, address)
                                }}
                            >{venueInfo.venueInfo.address}</Item>
                            <Item
                                thumb={<Icon type="phone" style={{color: "#FD9D24"}}/>}
                                onClick={() => {
                                    const telephone = venueInfo.venueInfo.telphone;
                                    window.location.href = "tel://" + telephone;
                                }}
                                arrow="horizontal"
                            >
                                {venueInfo.venueInfo.telphone}
                            </Item>
                        </List>
                    </Flex.Item>
                </WingBlank>
            </div>
        )
    }
}


const mapStateToProps = (venue) => {
    return {
        venueInfo: venue.venue.venueInfo
    }
};

const mapDispatchToProps = (dispatch) => ({
    getVenueDetail: (id) => dispatch(getVenueDetail(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Space);